import logRocket from 'logrocket'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { useHostServices } from '../HostServices'
import { AlertsPayload } from '../CustomizeDashboard/Widgets/BadgeWidget/types'

type AlertsResponse = AlertsPayload | void

const alertsFallback = { alerts: [], alertsContact: null }

export function useAlertsApi(): UseQueryResult<AlertsResponse> {
  const { utils, session } = useHostServices()

  const CSRFChallengeToken = session.data?.CSRFChallengeToken ?? ''
  const token = session.data && session.data.access_token

  const getCustomAlertsApi = async (): Promise<AlertsResponse> => {
    return utils.fetch
      .CAPI<AlertsResponse>({
        url: '/alerts?category=custom',
        method: 'GET',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      })
      .then(res => res.payload ?? alertsFallback)
      .catch(error => {
        if (error instanceof Error) {
          logRocket.captureMessage(
            `ally-next-remote-dashboard: useAlertsApi Error: ${error.message}`,
          )
          throw new Error(error.message)
        }
      })
  }

  return useQuery(
    ['get-custom-alerts', [token, CSRFChallengeToken]],
    getCustomAlertsApi,
    {
      enabled: !!token && !!CSRFChallengeToken,
    },
  )
}
